import { PaginationProps, Table, TableProps } from 'antd';
import { ColumnsType, TableRowSelection } from 'antd/es/table/interface';
import { TableShell } from './styles';
import { useI18n } from '../../shared/i18n';

interface ITableProps extends TableProps<any> {
  loading: boolean;
  dataSource: any[];
  rowKey?: string;
  rowSelection?: TableRowSelection<any> | undefined;
  columns?: ColumnsType<any> | undefined;
  page: number | undefined;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  pages: number | undefined;
  limit: number | undefined;
  setLimit?: React.Dispatch<React.SetStateAction<number>>;
  style?: React.CSSProperties;
}

export const ATable: React.FC<ITableProps> = ({
  loading,
  dataSource,
  columns,
  rowKey,
  rowSelection,
  page,
  setPage,
  pages,
  limit,
  setLimit,
  style,
}) => {
  const { t } = useI18n();

  const onChange: PaginationProps['onChange'] = (pageNumber) => {
    setPage(pageNumber);
  };

  return (
    <TableShell>
      <Table
        style={style}
        rowSelection={rowSelection}
        scroll={{ y: 510 }}
        loading={loading}
        dataSource={dataSource}
        columns={columns}
        rowKey={rowKey ?? 'id'}
        locale={{
          emptyText: t('table.empty'),
        }}
        pagination={{
          total: pages,
          showTotal: (total, range) =>
            t('table.pagination', {
              start: range[0],
              end: range[1],
              total,
            }),
          defaultPageSize: limit,
          onShowSizeChange(current, size) {
            setLimit && setLimit(size);
          },
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          current: page,
          onChange: onChange,
        }}
      />
    </TableShell>
  );
};
